const errorStatuses = [
  "failed",
  "error",
  "invalid_plan",
  "invalid_zip",
  "invalid_iccid",
  "timeout",
  "sim_inactive",
  "suspended",
  "invalid_areacode",
  "cancelled",
  "canceled",
  "invalid_msisdn",
  "invalid_status",
  "cooldown",
  "sim not found.",
  "offline",
  "invalid_organization",
  "credential_not_found",
  "imsi_not_found",
  "update_error",
  "address_error",
];
const pendingStatuses = ["pending", "in_progress", "submitted", "portin_request"];

const telitChangePlanPendingStatus = [
  ...pendingStatuses,
  "deactivating",
  "deactivated",
  "activating",
  "activated",
];

const getChipColor = (status, telitChangePlan = false) => {
  if (telitChangePlan && telitChangePlanPendingStatus.includes(status)) {
    return "warning";
  }

  switch (status) {
    case "in_progress":
    case "pending":
    case "portin_request":
    case "update_request":
      return "warning";
    case "invalid_iccid":
    case "error":
    case "failed":
    case "invalid_plan":
    case "invalid_zip":
    case "invalid_areacode":
    case "timeout":
    case "suspended":
    case "cancelled":
    case "canceled":
    case "invalid_msisdn":
    case "invalid_status":
    case "cooldown":
    case "offline":
    case "sim not found.":
    case "invalid_organization":
    case "credential_not_found":
    case "imsi_not_found":
    case "update_error":
    case "address_error":
      return "error";
    case "already_active":
    case "sim_inactive":
    case "already_deactivated":
    case "already_paused":
    case "already_refilled":
    case "already_active_bad_msisdn":
    case "already_ported":
      return "info";
    default:
      return "success";
  }
};

const getStatusCount = (statusData, telitChangePlan = false) => {
  const count = { success: 0, error: 0, pending: 0 };

  Object.keys(statusData).forEach((status) => {
    if (errorStatuses.includes(status?.toLowerCase())) {
      count.error = count.error + statusData[status];
    } else if (
      (telitChangePlan && telitChangePlanPendingStatus.includes(status)) ||
      pendingStatuses.includes(status)
    ) {
      count.pending = count.pending + statusData[status];
    } else {
      count.success = count.success + statusData[status];
    }
  });

  return count;
};

const CLIENTS = {
  ultra: "ultra",
  telit: "telit",
  sparq: "sparq",
  cricket: "cricket",
  verizon: "verizon",
  tmobile: "tmobile",
  selectel: "selectel",
  imsi: "imsi",
  opn: "opn",
  tmobilej: "tmobilej",
  vs: "vs",
  it: "it",
  nyx: "nyx",
};

const OPERATIONS = {
  activate: "activate",
  change_number: "change_number",
  change_plan: "change_plan",
  change_sim: "change_sim",
  deactivate: "deactivate",
  pause: "pause",
  restore: "restore",
  sim_info: "sim_info",
  unpause: "unpause",
  refill: "refill",
  portin: "portin",
  reset: "reset",
  hotline: "hotline",
  wifi_calling: "wifi_calling",
  imsi_create: "imsi_create",
  imsi_delete: "imsi_delete",
  imsi_workflow: "imsi_workflow",
};

const NOT_RETRY_STATUSES = ["active", "already_active", "completed", "changed"];
class CustomError extends Error {
  constructor(message) {
    super(message);
    this.name = "CustomError";
  }
}

const getValidRetryLines = (batchData) =>
  batchData.reduce((acc, item) => {
    const extraData = typeof item.extra_data === 'string' 
      ? JSON.parse(item.extra_data || '{}') 
      : (item.extra_data || {});
    
    if (
      !NOT_RETRY_STATUSES.includes(item.status) &&
      (extraData.user_zip || extraData.user_areacode)
    ) {
      acc.push(item);
    }
    return acc;
  }, []);

export {
  getChipColor,
  CLIENTS,
  getStatusCount,
  OPERATIONS,
  NOT_RETRY_STATUSES,
  CustomError,
  getValidRetryLines,
};
